import type { FetchedShiftType, ShiftTypeList } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  SHIFT_TYPES_QUERY_KEY,
  SHIFT_TYPES_UPDATE_QUERY_KEY,
  SHIFT_TYPES_URL
} from './queryConstants'
import type { ShiftFormType } from './useShiftTypesList'

type UseShiftTypesUpdateProps = {
  onSuccess?: () => void
}

type UseShiftTypesUpdateReturn = {
  updateShiftTypes: (values: ShiftFormType) => Promise<FetchedShiftType>
  isUpdateShiftTypesLoading: boolean
}

export const useShiftTypesUpdate = ({
  onSuccess
}: UseShiftTypesUpdateProps): UseShiftTypesUpdateReturn => {
  const queryClient = useQueryClient()

  const updateFunction = (values: { types: ShiftTypeList }) =>
    postJSON({
      url: SHIFT_TYPES_URL,
      method: 'PUT',
      isRota: true,
      json: values
    })

  const {
    mutateAsync: updateShiftTypes,
    isLoading: isUpdateShiftTypesLoading
  } = useMutation<FetchedShiftType, unknown, any>(
    [SHIFT_TYPES_UPDATE_QUERY_KEY],
    updateFunction,
    {
      onSuccess: () => {
        onSuccess?.()
        queryClient.invalidateQueries([SHIFT_TYPES_QUERY_KEY])
      }
    }
  )

  return {
    updateShiftTypes,
    isUpdateShiftTypesLoading
  }
}
